var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:people-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.27 19.4825C45.9399 24.0281 42.54 27.5298 38.8324 27.5298C35.1249 27.5298 31.7194 24.0292 31.3948 19.4825C31.0568 14.7537 34.3665 11.4353 38.8324 11.4353C43.2984 11.4353 46.6081 14.8397 46.27 19.4825Z",
    stroke: "white",
    strokeWidth: 3.3992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M38.8325 34.6829C31.4884 34.6829 24.4261 38.3008 22.6569 45.3466C22.4225 46.2787 23.0118 47.2008 23.9776 47.2008H53.6886C54.6543 47.2008 55.2403 46.2787 55.0093 45.3466C53.24 38.1879 46.1777 34.6829 38.8325 34.6829Z",
    stroke: "white",
    strokeWidth: 3.3992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.5088 21.4876C23.2451 25.1178 20.4977 27.9768 17.5362 27.9768C14.5747 27.9768 11.8228 25.1189 11.5636 21.4876C11.2943 17.711 13.9684 15.0118 17.5362 15.0118C21.104 15.0118 23.7782 17.7803 23.5088 21.4876Z",
    stroke: "white",
    strokeWidth: 3.3992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.1835 34.9064C22.1495 33.9821 19.9092 33.6266 17.5348 33.6266C11.6748 33.6266 6.02903 36.5158 4.61476 42.1433C4.42882 42.8877 4.89987 43.6242 5.67068 43.6242H18.3236",
    stroke: "white",
    strokeWidth: 3.3992,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.4167664df409f221bf2e02c2338860c9.svg";
export { ForwardRef as ReactComponent };